import { useStaticQuery, graphql } from 'gatsby';

const useFooterQuery = () => {
	const data = useStaticQuery(graphql`
		query GET_FOOTER_DATA {
			wp {
				acfOptionsFooter {
					acfFooterSettings {
						footer {
							socialMedia {
								link {
									label
									url
									fieldGroupName
								}
							}
							primaryNavigationItems {
								heading
								items {
									link {
										label
										url
									}
								}
							}
							secondaryNavigationItems {
								link {
									label
									url
								}
							}
						}
					}
				}
			}
		}
	`);

	return data;
};

export default useFooterQuery;
